export default from './desktop-header';



// WEBPACK FOOTER //
// ./app/containers/desktop-header/index.js